import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

blue.ready('eventPromo', '.eventPromo', eventPromo => {
  let container = eventPromo.querySelector('.eventPromo__swiper');
  let wrapper = eventPromo.querySelector('.eventPromo__wrapper');
  let slides = [...eventPromo.querySelectorAll('.eventPromo__slide')];
  let pagination = eventPromo.querySelector('.eventPromo__pagination');
  let nextEl = eventPromo.querySelector('.swiper-button-next');
  let prevEl = eventPromo.querySelector('.swiper-button-prev');

  container.classList.add('swiper-container');
  wrapper.classList.add('swiper-wrapper');
  slides.forEach(s => s.classList.add('swiper-slide'));

  const setupSwiper = (
    allowTouchMove,
    loopSlides,
    centeredSlides,
    slidesPerView
  ) => {
    if (slides.length > 1) {
      eventPromo.classList.remove('is-single');
      const swiper = new Swiper(container, {
        slidesPerView: slidesPerView,
        spaceBetween: 30,
        loop: loopSlides,
        // centeredSlides: centeredSlides,
        // allowTouchMove: allowTouchMove,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true
        },
      });
    } else {
      eventPromo.classList.add('is-single');
    }
  };

  const resizing = () => {
    let slideCount = slides.length;

    let isInteractive = true;
    let allowTouchMove = true;
    let loopSlides = true;
    let centeredSlides = true;
    let slidesPerView = 1;

    if (slideCount > 3) {
      if (blue.prop.media.lg.matches) {
        slidesPerView = 3;
      } else if (blue.prop.media.md.matches) {
        slidesPerView = 2;
      }
    } else if (slideCount === 3) {
    
      if (blue.prop.media.lg.matches) {
        slidesPerView = 3;
        isInteractive = false;
      } else if (blue.prop.media.md.matches) {
        slidesPerView = 2;
      }

    } else if (slideCount === 2) {
      if (blue.prop.media.md.matches) {
        slidesPerView = 2;
        loopSlides = false;
        isInteractive = false;
        centeredSlides = false;
        allowTouchMove = false;
      }
    } else {
      isInteractive = false;
    }

    if (isInteractive) {
      eventPromo.classList.add('is-interactive');
    } else {
      eventPromo.classList.remove('is-interactive');
    }

    // console.log(`isInteractive: ${isInteractive}`);
    // console.log(`loopSlides: ${loopSlides}`);
    // console.log(`centeredSlides: ${centeredSlides}`);
    // console.log(`spaceBetween: ${spaceBetween}`);
    // console.log(`slidesPerView: ${slidesPerView}`);

    setupSwiper(allowTouchMove, loopSlides, centeredSlides, slidesPerView);
  };

  const initialize = () => {
    resizing();
    window.addEventListener('resize', resizing);
  };

  initialize();
});
